const { Component } = Shopware;

Component.override('sw-settings-cache-index', {

    methods: {
        createdComponent() {
            this.$super('createdComponent');

            this.indexers['acris_faq.indexer'] = [];
        },
    }
});
